module.exports = __webpack_public_path__ + "img/icon_management04.47e59298.svg";